import { UserProfile } from 'types/types/userProfile'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// export interface User {
//   email: string
//   user_display_name?: string
//   user_role: string[]
//   user_id: string
//   given_name: string
//   family_name: string
//   phone_number: string
//   subscription_type?: string
//   subscription?: string
//   all_subscriptions?: string[]
// }

export interface UserAuthToken {
  exp?: number
  iat?: number
  token: string
}

interface AuthStore {
  user: UserProfile | null
  userToken: UserAuthToken | null
  setUser: (user: UserProfile) => void
  setToken: (token: UserAuthToken) => void
  logout: () => void
}

const useAuthStore = create(
  persist<AuthStore>(
    (set) => ({
      user: null,
      userToken: null,
      setUser: (user) => {
        set({ user })
      },
      setToken: (userToken) => {
        set({ userToken })
      },
      logout: () => {
        set({ user: null, userToken: null }) // Clear both user and token on logout
      }
    }),
    {
      name: 'userLogin' // Key for local storage persistence
    }
  )
)

export default useAuthStore
